// extracted by mini-css-extract-plugin
module.exports = {"logosContainer":"sponsor-logos_logosContainer__aRtZ5","logoContainer":"sponsor-logos_logoContainer__GLnwY","logoContainerSidenav":"sponsor-logos_logoContainerSidenav__0wwER"};